import angular from 'angular';

angular
  .module('cxSettings')
  .controller('AddCompanyDialogCtrl', [
    '$element',
    '$http',
    '$scope',
    'authService',
    'appUrls',
    'flySvc',
    'close',
    'dataCache',
    'checkTenantConfiguration',
    addCompanyDialogCtrl,
  ]);

function addCompanyDialogCtrl(
  $element,
  $http,
  $scope,
  authService,
  appUrls,
  flySvc,
  close,
  dataCache,
  checkTenantConfiguration,
) {
  var vm = this;
  vm.isNetherlandsConfiguration = checkTenantConfiguration('[5]');
  vm.company = {
    name: undefined,
    enterpriseNumber: undefined,
    kvkNumber: undefined,
    countryCode:
      dataCache.getArray('defaultcompany') && dataCache.getArray('defaultcompany').countryCode
        ? dataCache.getArray('defaultcompany').countryCode || 'BE'
        : 'BE',
  };

  vm.save = function() {
    vm.saving = true;
    var model = { ...vm.company };

    $http({
      method: 'post',
      url: appUrls.api + '/api/company/create',
      data: model,
    })
      .then(function(response) {
        var result = response.data;
        $element.modal('hide');
        close(result, 500);
      })
      .catch(function(error) {
        flySvc.error(error.code, error.parameters);
      })
      .finally(function() {
        vm.saving = false;
      });
  };

  vm.cancel = function() {
    close(null, 500);
  };
}
